module.exports = __webpack_public_path__ + "img/header.009ffc0a.jpeg";